import { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import "../styling/sidebar.css";
import "../styling/incomepop.css";
import GetUser from "../services/get-user";
import { CircularProgress } from "@material-ui/core";

export default function IPopup({ closeModal, setReloadTableData }) {
  const [name, setName] = useState("");
  const [revenue] = useState(0);
  const [source, setSource] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);

  const platformName: any = [
    {
      value: "Etsy",
      label: "Etsy",
    },
    {
      value: "Poshmark",
      label: "Poshmark",
    },
    {
      value: "Depop",
      label: "Depop",
    },
    {
      value: "Shopify",
      label: "Shopify",
    },
    {
      value: "StockX",
      label: "StockX",
      subOption: [
        {
          value: "Level 1",
          label: "Level 1",
        },
        {
          value: "Level 2",
          label: "Level 2",
        },
        {
          value: "Level 3",
          label: "Level 3",
        },
        {
          value: "Level 4",
          label: "Level 4",
        },
        {
          value: "Level 5",
          label: "Level 5",
        },
      ],
    },
    {
      value: "GOAT",
      label: "GOAT",
    },
    {
      value: "eBay",
      label: "eBay",
    },
    {
      value: "Instagram",
      label: "Instagram",
    },
    {
      value: "Facebook Marketplace",
      label: "Facebook Marketplace",
    },
    {
      value: "Grailed",
      label: "Grailed",
    },
    {
      value: "Mercari",
      label: "Mercari",
    },
    {
      value: "My own website",
      label: "My own website",
    },
    {
      value: "Alias",
      label: "Alias",
    },
    {
      value: "Vinted",
      label: "Vinted",
    },
    {
      value: "OfferUp",
      label: "OfferUp",
    },
    {
      value: "Custom",
      label: "Custom",
    },
  ];

  const user = GetUser();

  function validateForm() {
    return name.length > 0 && source.length > 0 && revenue >= 0;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      //'http://localhost:8080/income/add_income'
      //return axios.post('http://localhost:8080/income/add_income', {
      return axios
        .post("https://sotira-back-test.herokuapp.com/income/add_income", {
          userID: user.userID,
          source,
          note,
          income: revenue,
          iname: name,
        })
        .then((response) => {
          setLoading(false);
          closeModal(false);
          setReloadTableData((prevState) => !prevState);
        })
        .catch((error) => {
          setLoading(false);
          closeModal(false);
        });
    } catch (e: any) {
      setLoading(false);
      closeModal(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="name" className="form-group required">
        <Form.Label className="control-label"> Name of Business </Form.Label>
        <Form.Control
          autoFocus
          type="name"
          value={name}
          required
          onChange={(e) => setName(e.target.value)}
        />
      </Form.Group>
      {/* Change in question format
      <Form.Group controlId="revenue" className="form-group required">
        <Form.Label className="control-label"> Monthly Revenue $ </Form.Label>
        <Form.Control
          autoFocus
          type="number"
          step={.01}
          defaultValue={empty}
          required
          onChange={(e) => setRevenue(Number(e.target.value))}
        />
      </Form.Group>
      */}

      <Form.Group controlId="source" className="form-group required">
        <Form.Label className="control-label"> Platform (ex: Etsy) </Form.Label>
        <input
          autoFocus
          className="form-control"
          type="text"
          value={source}
          list="source"
          required
          onChange={(e) => setSource(e.target.value)}
        />
        <datalist id="source">
          {platformName.map((item: any) => (
            <option key={item.label} value={item.value} />
          ))}
        </datalist>
      </Form.Group>
      <Form.Group controlId="note" className="form-group">
        <Form.Label className="control-label"> Note </Form.Label>
        <Form.Control
          autoFocus
          type="note"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </Form.Group>
      <Button block size="sm" type="submit" disabled={!validateForm()}>
        {loading ? (
          <>
            <CircularProgress className="file-loader mr-3" /> Uploading{" "}
          </>
        ) : (
          "Add Stream"
        )}
      </Button>
    </Form>
  );
}
